import React, { useEffect } from 'react';
import { Breadcrumbs } from '../../library/common/components';
import { routes } from '../../main/routes';
import clock from '../../resources/img/clock.svg';
import whatsapp from '../../resources/img/whatsapp.svg';
import location from '../../resources/img/location.svg';
import mail from '../../resources/img/mail.svg';
import { Link } from 'react-router-dom';

const Services = (props) => {
  const crumbs = routes
    .filter(({ path }) => props.match.path.includes(path))
    .map(({ path, ...rest }) => ({
      path: Object.keys(props.match.params).length
        ? Object.keys(props.match.params).reduce(
          (path, param) => path.replace(
            `:${param}`, props.match.params[param]
          ), path
          )
        : path,
      ...rest
    }));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
  <div className='services-page'>
    <Breadcrumbs crumbs={crumbs} title={'Nuestros servicios'}/>
    <div className='content'>
      <div className='menu'>
        <div>
          <span className='active'>Todos los servicios</span>
          <Link to ='services/1'><span>Reformas integrales</span></Link>
          <Link to ='services/1'><span>Reforma de cocina</span></Link>
          <Link to ='services/1'><span>Reforma de baño</span></Link>
          <Link to ='services/1'><span>Climatización</span></Link>
          <Link to ='services/1'><span>Locales y oficinas comerciales</span></Link>
          <Link to ='services/1'><span>Instalación eléctrica</span></Link>
        </div>
        <div className='info'>
          <span className='title'>
            Contáctanos
          </span>
          <div className='option'>
            <strong>Estamos ubicados en</strong>
            <span>
              <a href="http://maps.google.com/?q=Carrer Badajoz 168, 08018, Barcelona">
                <img src={location} />
                Carrer Badajoz 168, 08018, Barcelona
              </a>
            </span>
          </div>
          <div className='option'>
            <strong>Info de contacto</strong>
            <span>
              <a href='https://api.whatsapp.com/send?phone=+34555123456' title='Chateemos por whatsapp' target="_blank">
                <img src={whatsapp} />
                +34 555 12 34 56
              </a>
            </span>
            <span>
              <a href='mailto:info@selo.es' title='Envíanos un email' target="_blank">
                <img src={mail} />
                info@selo.es
              </a>
            </span>
          </div>
          <div className='option'>
            <strong>Nuestros horarios</strong>
            <span>
              <img className='clock' src={clock} />
              Lun-Sat: 8:00 - 19:00
            </span>
          </div>
        </div>
      </div>
      <div className='body'>
        <div className='service'>
          <Link to ='services/1'>
            <div className={'img integral'}></div>
            <div className='tile'>
              <span className='title'>Reforma integrales</span>
              <span className='text'>
              Ofrecemos las mejores soluciones para viviendas, comunidades, locales y oficinas comerciales.<br/>
              Abarcamos todos los trabajos que pueden ser necesarios para realizar una reforma:<br/><br/>
              Albañilería y revestimientos, Solados y alicatados, Instalaciones de Fontanería y Saneamiento,
              Instalaciones eléctricas y climatización, Carpinterías de aluminio y pvc, Pladur y Pinturas,
              Instalacion de suelos en general.
              </span>
              <div className='more'>
                + <span>Saber más</span>
              </div>
            </div>
          </Link>
        </div>
        <div className='service'>
          <Link to ='services/1'>
            <div className={'img kitchen'}></div>
            <div className='tile'>
              <span className='title'>Reforma de cocinas</span>
              <span className='text'>
                Ofrecemos un servicio integral, abarcando desde la realización del proyecto hasta la planificación y ejecución de la obra. <br/>
                Además, diseñaremos vuestra cocina para que os ofrezca todas las prestaciones necesarias y utilizaremos los mejores materiales
                para garantizar unos acabados de calidad. <br/>¡Llámanos y dinos cómo quieres que sea tu cocina!
              </span>
              <div className='more'>
                + <span>Saber más</span>
              </div>
            </div>
          </Link>
        </div>
        <div className='service'>
          <Link to ='services/1'>
            <div className={'img bathroom'}></div>
            <div className='tile'>
              <span className='title'>Reforma de baños</span>
              <span className='text'>
                Aportamos soluciones integrales de máxima calidad y garantizamos unos impecables acabados. Además, realizamos desde los cambios de
                placa de ducha hasta el mobiliario, contando para ello con un excelente equipo de especialistas, profesionales cualificados que
                tienen mucha experiencia de trabajo en el sector.
              </span>
              <div className='more'>
                + <span>Saber más</span>
              </div>
            </div>
          </Link>
        </div>
        <div className='service'>
          <Link to ='services/1'>
            <div className={'img climatisation'}></div>
            <div className='tile'>
              <span className='title'>Climatización</span>
              <span className='text'>
                Después de realizar un estudio de los metros cúbicos y los cerramientos, se plantea la climatización adecuada para cada espacio, teniendo
                en cuenta también el tipo de equipo que mejor se adapte.
              </span>
              <div className='more'>
                + <span>Saber más</span>
              </div>
            </div>
          </Link>
        </div>
        <div className='service'>
          <Link to ='services/1'>
            <div className={'img restaurant'}></div>
            <div className='tile'>
              <span className='title'>Locales y oficinas comerciales</span>
              <span className='text'>
                Adecuación de locales como obra nueva, garantizando en ambos casos unos excelentes resultados en todos los parámetros: aprovechamiento de 
                los espacios, funcionalidad, estética, calidad de los acabados, etc.  
              </span>
              <div className='more'>
                + <span>Saber más</span>
              </div>
            </div>
          </Link>
        </div>
        <div className='service'>
          <Link to ='services/1'>
            <div className={'img electrical'}></div>
            <div className='tile'>
              <span className='title'>Instalación eléctrica</span>
              <span className='text'>
                En base al proyecto realizado, ofrecemos la instalación eléctrica y de datos según las necesidades de los puestos de trabajo, integrándolo
                al espacio y al mobiliario. 
              </span>
              <div className='more'>
                + <span>Saber más</span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  </div>
)};

export default Services;
